<template>
  <div class="view-box" v-if="primitive">
    <span v-if="isView">{{ originVal }}</span>
    <span v-else>{{ hideNum(primitive) }}</span>
    <div @click="handleView" style="color: #409eff; cursor: pointer">
      <el-icon class="is-loading" v-if="loading"><Loading /></el-icon>
      <template v-else>
        <el-icon v-if="isView"><View /></el-icon>
        <el-icon v-else><Hide /></el-icon>
      </template>
    </div>
  </div>
</template>

<script setup>
import { operrecordAceInfo } from '@/api/ywgl/sensitiveInfo';
const props = defineProps({
  primitive: {
    type: String,
    default: '',
    require: true,
  },
  type: {
    type: Number, //0 意向学员， 1报名学员,2财税企业客户  3就业企业联系人
    validator: (value) => [0, 1, 2, 3].includes(value),
    default: 1,
  },
  id: {
    type: String, //意向学员或报名学员id
    default: '',
  },
  field: {
    type: Number, //0手机号，1身份证号， 2微信号
    validator: (value) => [0, 1, 2].includes(value),
    default: 0,
  },
  fun: {
    type: String, //模块名称
    default: '',
  },
});

const route = useRoute();
const isView = ref(false); //是否查看
const originVal = ref(''); //原始值

const loading = ref(false);
async function handleView() {
  isView.value = !isView.value;
  if (unref(isView)) {
    if (props.id) {
      loading.value = true;
      try {
        const res = await operrecordAceInfo({ type: props.type, id: props.id, field: props.field, fun: props.fun });
        originVal.value = res.msg;
        loading.value = false;
      } catch {
        originVal.value = '';
        loading.value = false;
      }
    } else {
      originVal.value = props.primitive;
    }
  }
}

//星号隐藏数字
function hideNum(val) {
  if (/\*+/.test(val)) return val;
  if (props.field === 2) {
    return val.toString().replace(/(\S{1})\S*/, '$1*******');
  } else {
    let str = val.toString().replace(/(\w{3})(\w*)(\w{4})/g, (match, p1, p2, p3) => {
      let length = p2.toString().length;
      let hideStr = '*'.repeat(length);
      return p1 + hideStr + p3;
    });
    return str;
  }
}

watch(
  () => props.primitive,
  (val) => {
    if (val) {
      isView.value = false;
    }
  }
);
</script>

<style lang="scss" scoped>
.view-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  max-width: 100px;
  align-items: center;
  > span {
    white-space: nowrap;
  }
}
</style>
